import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

/**
 * Formats date string to dd.MM.yy format
 * Returns placeholder if date is invalid or missing
 */
export const formatFanficDate = (dateString?: string): string => {
  if (!dateString) return '--.--.----';
  const date = new Date(dateString);
  return format(date, 'dd.MM.yy', { locale: ru });
};
